"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGatewayHub = exports.HUB_TYPE_GATEWAY = exports.HubDeviceType = exports.HubStatus = void 0;
var HubStatus;
(function (HubStatus) {
    HubStatus["Active"] = "ACTIVE";
    HubStatus["Inactive"] = "INACTIVE";
    HubStatus["Maintenance"] = "MAINTENANCE";
    HubStatus["Pending"] = "PENDING";
})(HubStatus = exports.HubStatus || (exports.HubStatus = {}));
var HubDeviceType;
(function (HubDeviceType) {
    HubDeviceType["HUB"] = "HUB";
    HubDeviceType["GATEWAY"] = "GATEWAY";
})(HubDeviceType = exports.HubDeviceType || (exports.HubDeviceType = {}));
/**
 * The only `hubType` literal honored anywhere. `createHub` uppercases whatever
 * it's given to match this, and the resolvers compare against it exactly — a
 * lowercase 'gateway' row would silently behave as a normal hub.
 */
exports.HUB_TYPE_GATEWAY = 'GATEWAY';
/**
 * A screenless Z-Wave gateway/extender: its own hub row, IoT thing and Z-Wave
 * network, but no display, no web-hub install and no backlight. Anything that
 * assumes a hub has a screen (web-hub OTA, backlight commands, kiosk state)
 * must check this first.
 */
const isGatewayHub = (hub) => hub?.hubType === exports.HUB_TYPE_GATEWAY;
exports.isGatewayHub = isGatewayHub;
